/**
 * @voltxampere/presets — Lookup helpers over `ALL_PRESETS`
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ALL_PRESETS } from "./presets/index.js";
/** Find a preset by stable id. Returns `undefined` for unknown ids. */
export function findPresetById(id) {
    return ALL_PRESETS.find((p) => p.id === id);
}
/** Filter presets in a given category, preserving registry order. */
export function presetsByCategory(category) {
    return ALL_PRESETS.filter((p) => p.category === category);
}
/** Total preset count — useful for the selector "X presets" badge. */
export const PRESET_COUNT = ALL_PRESETS.length;
/** Category coverage — counts per category for the dialog left panel. */
export function presetCountsByCategory() {
    const counts = {
        basic: 0,
        filter: 0,
        amplifier: 0,
        digital: 0,
        power: 0,
        // Sprint 50 ADR-0072 — extensions.
        oscillator: 0,
        mcu: 0,
    };
    for (const p of ALL_PRESETS) {
        counts[p.category] += 1;
    }
    return counts;
}
//# sourceMappingURL=registry.js.map